export default __webpack_public_path__ + "static/media/ontime-canje.e87acd6c.svg";